export const light = {
    alternate: {
        main: '#f7faff',
        dark: '#edf1f7',
    },
    cardShadow: 'rgba(23, 70, 161, .11)',
    mode: 'light',
    primary: {
        main: '#13203d',
        light: '#417285',
        dark: '#13203d',
        contrastText: '#fff',
    },
    secondary: {
        light: '#d11f25',
        main: '#d11f25',
        dark: '#751e2e',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    warning: {
        light: '#ffd28e',
        main: '#8e5f00',
        dark: '#8e5f00',
        contrastText: '#fff',
    },
    info: {
        light: '#417285',
        main: '#417285',
        dark: '#13203d',
        contrastText: '#fff',
    },
    text: {
        primary: '#1e2022',
        secondary: '#677788',
        white: '#ffffff',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
        paper: '#ffffff',
        default: '#ffffff',
        level2: '#f5f5f5',
        level1: '#ffffff',
        main: '#132246',
    },
};

export const dark = {
    alternate: {
        main: '#1a2138',
        dark: '#151a30',
    },
    cardShadow: 'rgba(0, 0, 0, .11)',
    common: {
        black: '#000',
        white: '#fff',
    },
    mode: 'dark',
    primary: {
        // Brand blues from logo for dark mode
        main: '#13203d',
        light: '#417285',
        dark: '#13203d',
        contrastText: '#fff',
    },
    secondary: {
        // Brand reds from logo for dark mode
        light: '#d11f25',
        main: '#d11f25',
        dark: '#751e2e',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    // Brand golds mapped to warning
    warning: {
        light: '#ffd28e',
        main: '#8e5f00',
        dark: '#8e5f00',
        contrastText: '#fff',
    },
    // Brand teals mapped to info
    info: {
        light: '#417285',
        main: '#417285',
        dark: '#13203d',
        contrastText: '#fff',
    },
    text: {
        primary: '#EEEEEF',
        secondary: '#AEB0B4',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#222B45',
        default: '#222B45',
        level2: '#333',
        level1: '#2D3748',
    },
};
